import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

// Styles
import styles from './PanelDivider.module.scss'

const PanelDivider = ({ className, children, icon, footer, header }) => {
  if (footer === undefined && header === undefined) {
    throw new Error('Header or Footer must be supplied as prop to PanelDivider')
  }

  const renderChildrenWithIcon = () => {
    return (
      <div className={styles.wrapper}>
        <div className={styles.icon}>{icon()}</div>
        {children}
      </div>
    )
  }
  return (
    <div className={classnames(styles.root, className)}>
      {footer && <hr className={styles.hr} />}
      {icon && renderChildrenWithIcon()}
      {!icon && children}
      {header && <hr className={styles.hr} />}
    </div>
  )
}

PanelDivider.propTypes = {
  header: PropTypes.bool,
  footer: PropTypes.bool,
  className: PropTypes.string,
  children: PropTypes.any,
  icon: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.element,
    PropTypes.object,
  ]),
}

export default PanelDivider
